import spingif from "assets/images/gif/spin1.png";
import { FC } from "react";
import { DIGIPOSTHEME } from "theme/digiPosTheme";

type insideSpinnerProp = {
  width: string;
  height: string;
  isWhite?: boolean;
};
const InsideSpinner: FC<insideSpinnerProp> = ({
  width,
  height,
  isWhite = false,
}) => {
  return (
    <img
      src={spingif}
      alt='spinner'
      height={height}
      width={width}
      style={{
        backgroundColor: isWhite
          ? DIGIPOSTHEME.colors.headerRed
          : DIGIPOSTHEME.colors.transparent,
        borderRadius: "5px",
      }}
    />
  );
};

export default InsideSpinner;
